/* InitialState.ts */

/* Constants */
import { CustomFeature } from "src/shared/constants/common/CustomFeature";

/* Interfaces */
import {
  InsightsFilterProps,
  FilterComponentType,
} from "src/shared/interfaces/insights-filter/InsightsFilter";

const INITIAL_MAIN_CONDITION = {
  value: undefined,
  initialValue: undefined,
  items: [],
  disabled: false,
  show: true,
  componentType: FilterComponentType.DROPDOWN,
  isLoading: false,
};

export const INITIAL_INSIGHTS_FILTER_STATE: InsightsFilterProps =
  {
    mainCondition: INITIAL_MAIN_CONDITION,
    features: {
      value: "Age at first diagnosis (buckets)",
      initialValue: "Age at first diagnosis (buckets)",
      items: [],
      disabled: false,
      show: true,
      componentType: FilterComponentType.DROPDOWN,
    },
    cohorts: {
      value: undefined,
      initialValue: undefined,
      items: [],
      disabled: false,
      show: true,
      componentType: FilterComponentType.DROPDOWN,
    },
    timePeriod: {
      value: { firstYear: "2013", lastYear: "2024" },
      initialValue: { firstYear: "2013", lastYear: "2024" },
      previousValue: undefined,
      show: true,
      componentType: FilterComponentType.SLIDER,
    },
    customFeature: {
      value: undefined,
      initialValue: CustomFeature.TREATMENT,
      items: [],
      disabled: false,
      show: true,
      componentType: FilterComponentType.DROPDOWN,
    },
    careSites: {
      value: undefined,
      initialValue: undefined,
      items: [],
      show: true,
      componentType: FilterComponentType.MULTI_SELECT,
    },
  };
